<template>
    <div>
        <p style="text-align: center; font-size: 16px"><b>Contact Card</b></p>
        <p>
            <b>Contact Name</b><br/>
            {{value.full_name_label}}
        </p>

        <p
            v-for="(item, index) in value.phone_numbers"
            :key="index"
        >
            <v-row>
                <v-col>
                    <b>Phone Number</b><br/>
                    {{prettyPrintPhoneNumber(item)}}
                </v-col>
            </v-row>
        </p>

        <p
            v-if="pretty_customer_phone_number != null"
        >
            <v-row>
                <v-col>
                    <b>Phone Number</b><br/>
                    {{pretty_customer_phone_number}}
                </v-col>
            </v-row>
        </p>

        <p
            v-if="has(value.email_address)"
        >
            <b>Email</b><br/>
            {{value.email_address}}
        </p>

        <p
            v-if="has(value.business_name)"
        >
            <b>Company</b><br/>
            {{value.business_name}}
        </p>
    </div>
</template>

<script>
const E164 = require('@/js/E164.js');

export default {
    props: {
        value: {
            type: Object,
            default: function () { return {}; }
        },
    },

    methods: {
        has(value)
        {
            if ( value == null ) return false;
            if ( typeof value === 'string' && value.trim().length == 0 ) return false;
            return true;
        },

        prettyPrintPhoneNumber(endpoint)
        {
            if ( !endpoint || endpoint == '' ) return null;

            return E164.prettyPrintUsPhoneNumber(endpoint.phone_number);
        },
    },

    computed: {
        pretty_customer_phone_number() {
            if ( this.value == null ) return null;
            if ( this.value.phone_number == null ) return null;

            return E164.prettyPrintUsPhoneNumber(this.value.phone_number.phone_number);
        },

    },
}
</script>


<style lang="scss" scoped>

</style>
